import {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {User} from "../../services/UsersService";
import Pagination from "../pagination/Pagination";
import {SliceStatus} from "../BaseState";
import Search from "../search/Search";
import UsersListItem from "./UsersListItem";
import {list, setSearchParams, usersState} from "./UsersSlice";
import {UsersState} from "./UsersState";
import {setError} from "../error/ErrorHandlerSlice";
import {PaginationState} from "../pagination/PaginationState";
import {paginationState as pState} from "../pagination/PaginationSlice";
import {SearchState} from "../search/SearchState";
import {searchState as sState, setSearch, submit} from "../search/SearchSlice";
import {ZendeskState} from "../zendesk/ZendeskState";
import {getZendeskTicket, zendeskState as zState} from "../zendesk/ZendeskSlice";

const UserList = () => {
  const dispatch = useAppDispatch();

  const state: UsersState = useAppSelector(usersState);
  const paginationState: PaginationState = useAppSelector(pState);
  const searchState: SearchState = useAppSelector(sState);
  const zendeskState: ZendeskState = useAppSelector(zState);

  const loading = state.status === SliceStatus.loading;

  useEffect(() => {
    if (state.error) dispatch(setError(state.error));
  }, [dispatch, state.error]);

  useEffect(() => {
    if (!zendeskState.ticket && zendeskState.insideZendesk === null) {
      dispatch(getZendeskTicket())
        .unwrap()
        .then((ticket) => {
          if (ticket) {
            dispatch(setSearch(ticket.requester.email));
            dispatch(submit());
          }
        })
        .catch(() => {
          if (state.users.length === 0 && state.status === SliceStatus.idle && zendeskState.status === SliceStatus.idle) {
            dispatch(
              list({
                page: paginationState.page - 1,
                limit: paginationState.limit,
                search: searchState.submitted
              })
            );
          }
        });
    }
  });

  useEffect(() => {
    if (
      paginationState.limit !== state.searchParams.limit ||
      paginationState.page !== state.searchParams.page + 1 ||
      searchState.submitted !== state.searchParams.search
    ) {
      const searchParams = {
        page: paginationState.page - 1,
        limit: paginationState.limit,
        search: searchState.submitted
      };
      dispatch(setSearchParams(searchParams));
      dispatch(list(searchParams));
    }
  }, [
    dispatch,
    paginationState.limit,
    paginationState.page,
    searchState.submitted,
    state.searchParams.limit,
    state.searchParams.page,
    state.searchParams.search
  ]);

  return (
    <div>
      <Search disabled={loading} />
      <div className={`card ${loading ? "card-inactive" : ""}`}>
        <div className="card-body">
          <div className="list-group list-group-flush my-n3">
            {state.users.map((user: User) => {
              return <UsersListItem key={user.id} user={user} disabled={loading}></UsersListItem>;
            })}
          </div>
        </div>
      </div>
      <Pagination disabled={loading} itemsLength={state.users.length} />
    </div>
  );
};

export default UserList;
